import TrainTypeEditor from './train-type-editor';

export default TrainTypeEditor;